import { daysToHours, hoursToDays, type DurationUnit } from '@forecastify/shared';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 3 Nov 2026 · an hours RANGE filter, typed in the reader's unit.           │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * `decisions.md` DU-1. A range filter's value is `from..to` in HOURS — the address and the request
 * carry hours, as the wire does. In man-days mode the two bounds the toolbar shows and takes are
 * days, so these turn the stored value into the typed one and back. Hours mode is the identity.
 */
function mapBounds(value: string, map: (bound: number) => number): string {
  if (value === '') return value;
  const [from = '', to = ''] = value.split('..');
  const one = (bound: string): string => {
    if (bound.trim() === '') return '';
    const number = Number(bound);
    return Number.isFinite(number) ? String(map(number)) : bound;
  };
  return `${one(from)}..${one(to)}`;
}

/** The stored hours range, as the bounds the reader types. */
export function rangeForUnit(hoursRange: string, unit: DurationUnit): string {
  return unit === 'days' ? mapBounds(hoursRange, hoursToDays) : hoursRange;
}

/** The bounds the reader typed, as the hours range the address and the request carry. */
export function rangeFromUnit(typedRange: string, unit: DurationUnit): string {
  return unit === 'days' ? mapBounds(typedRange, daysToHours) : typedRange;
}
